import { WidgetConfig } from './web-component-config';

// Almacén simple de la config que el host pasa al web component.
// Se llena antes del bootstrap del módulo (ver main.ts).
let _config: WidgetConfig = {};

export function setWidgetConfig(config: WidgetConfig): void {
  _config = { ...config };
}

export function getWidgetConfig(): WidgetConfig {
  return _config;
}
